const eventsModule = angular.module('com.comtrade.azureCloud.backup.events', []);

eventsModule.component('events', require('./events.component'));
eventsModule.component('notifications', require('./dialogs/emailNotifications/notification.component'));
eventsModule.service('eventsPersistence', require('./events.persistence.service'));

module.exports = eventsModule;



// WEBPACK FOOTER //
// ./src/azurebackup/views/events/events.module.js